import { render } from "./NumberCard.vue?vue&type=template&id=d39b72f6"
import script from "./NumberCard.vue?vue&type=script&lang=js"
export * from "./NumberCard.vue?vue&type=script&lang=js"

import "./NumberCard.vue?vue&type=style&index=0&id=d39b72f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__